import * as React from "react";
import type { SVGProps } from "react";
const SvgCake = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#cake_svg__a)">
      <path
        fill="currentColor"
        d="M18 9h-5v-.18a2.9 2.9 0 0 0 1-.62 3 3 0 0 0 .21-4.2l-1.46-1.67A1 1 0 0 0 12 2a1 1 0 0 0-.75.33L9.67 4.11A3 3 0 0 0 9.8 8a2.9 2.9 0 0 0 1.2.81V9H6a4 4 0 0 0-4 4v8a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-8a4 4 0 0 0-4-4m-6.8-3.6.8-.9.73.82A1 1 0 0 1 13 6a1 1 0 0 1-.32.69A.93.93 0 0 1 12 7a1 1 0 0 1-.69-.32 1 1 0 0 1-.11-1.28M4 13a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3a3 3 0 0 1-3-3 1 1 0 0 0-2 0 3 3 0 0 1-6 0 1 1 0 0 0-2 0 3 3 0 0 1-3 3zm16 7H4v-2a5 5 0 0 0 4-2 5 5 0 0 0 8 0 5 5 0 0 0 4 2z"
      />
    </g>
    <defs>
      <clipPath id="cake_svg__a">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCake;
